
import { takeEvery, put, call, takeLatest } from "redux-saga/effects"

import {
    CREATE_PASSAGER
} from "./actionTypes"


import {
    createPassagerSuccess,
    apicreatePassagerError
} from "./actions"


import {
    createPassagerAPI,
} from "../../../api/form_register_passager_api"


function* createPassager({ payload: {params, callBackSuccess}}) {
    try {
        const response = yield call(createPassagerAPI, params)
        callBackSuccess()
        yield put(createPassagerSuccess(response))
    } catch (error) {
        yield put(apicreatePassagerError(error))
    }
}


function* PassagerSaga() {
    yield takeEvery(CREATE_PASSAGER, createPassager)

}

export default PassagerSaga
